import _ from 'lodash';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { authSelectors } from 'app-components/flux/auth';
import { subscriptionsSelectors } from 'app-components/flux/subscriptions';
import { getLogger, tracker } from 'app-components/utils/core';

import { getMixpanelDefaultProperties, getMixpanelUserData } from 'data/mixpanel/mixpanelSelectors';

const log = getLogger('utils/mixpanel.js');

const Mixpanel = () => {
  const authSession = useSelector(authSelectors.getAuthSession);
  const mixpanelUserData = useSelector(getMixpanelUserData);
  const mixpanelDefaultProps = useSelector(getMixpanelDefaultProperties);
  const subscriptionTrackingProps = useSelector((state) =>
    subscriptionsSelectors.getSubscriptionTrackingProps(state, authSession?.datasetId),
  );

  useEffect(() => {
    const subscriptionProps = {};
    Object.keys(subscriptionTrackingProps).forEach((propName) => {
      subscriptionProps[_.snakeCase(propName)] = subscriptionTrackingProps[propName];
    });
    log.debug('\nmixpanel identify: \n', {
      userId: authSession.qcsId,
      mixpanelDefaultProps,
      subscriptionProps,
      mixpanelUserData,
    });
    tracker.setDefaultProperties({ ...mixpanelDefaultProps, ...subscriptionProps });
    if (authSession.qcsId) {
      tracker.identify(authSession.qcsId);
      tracker.updateProfile(mixpanelUserData);
    }
  }, [authSession.qcsId, mixpanelUserData, mixpanelDefaultProps, subscriptionTrackingProps]);

  return null;
};

export default Mixpanel;
